export const variableAliasKeyword = "alias:";

export const varNameStartKeyword = "var-";

export const styleNameStartKeyword = "style-";
